import React from "react";
import ForgotPasswordForm from "../ForgotPasswordForm";

const ForgotPassword = () => {
  return (
    <div className="min-h-svh w-full flex items-center justify-center bg-muted text-foreground p-6">
      <ForgotPasswordForm />
    </div>
  );
};

export default ForgotPassword;
